<template>
  <header id="lid-header-overview" class="grid grid-cols-12 mx-4 lg:mx-6 xl:mx-12 2xl:mx-56" data-component="HeaderOverview">
    <div
      class="relative z-20 col-span-12 md:col-span-10 xl:col-span-9"
      :class="{ 'lg:col-span-8 xl:col-span-6 col-end-13 md:col-end-13 lg:col-end-13 xl:col-end-13 2xl:col-end-13 row-end-6 row-start-auto ml-4 sm:ml-10 md:ml-0': image }"
    >
      <div class="text-container" :class="{ 'rounded-l-xl bg-opacity-75 bg-app-lid--blue-prussian text-white p-4 sm:p-6 lg:p-8 xl:p-12 2xl:p-16': image, 'rounded-xl': !image }">
        <h1
          :class="{
            'mb-8 lg:mb-12 xl:mb-16 2xl:mb-20': !subtitle && !introduction && image,
            'mb-4 lg:mb-5 xl:mb-6 2xl:mb-8': (subtitle || introduction) && image,
            'text-2xl font-black leading-none md:text-3xl lg:text-4xl xl:text-5xl 2xl:text-6xl': image,
            'text-detail-page-title mb-5 sm:mb-8 md:mb-10 xl:mb-12 2xl:mb-16': !image,
          }"
        >
          <span>{{ title }}</span>
        </h1>
        <h2 v-if="subtitle" class="mb-2 text-lg leading-none xl:text-2xl">{{ subtitle }}</h2>
        <div
          v-if="introduction"
          class="prose prose--app prose--app--lid max-w-none text-base leading-snug xl:text-xl"
          :class="{ 'prose--app--text-white': image }"
          v-html="introduction"
        />
        <slot name="headerButtons" />
      </div>
    </div>
    <figure v-if="image" class="col-span-full row-end-7 row-start-1 overflow-hidden rounded-xl">
      <MoleculePicture class="header-overview-picture block w-full h-full object-cover" :image="image" />
    </figure>
  </header>
</template>

<script setup lang="ts">
interface Props {
  preTitle?: string
  title?: string
  subtitle?: string
  introduction?: string
  image?: object // Adjust object type if a specific shape is known
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.header-overview-picture {
  mix-blend-mode: darken;
}

.text-container {
  @apply relative;

  &::before {
    @apply block bg-app-lid--blue-prussian absolute top-0 h-full;
    z-index: -1;
    width: 16px;
    right: -16px;

    @screen lg {
      width: 24px;
      right: -24px;
    }

    @screen xl {
      width: 48px;
      right: -48px;
    }

    @screen 2xl {
      width: 56px;
      right: -56px;
    }
  }
}
</style>
